// Translations
import form from '../sections/form/translations/de'

// Translation: Password change > Landing (German)
export default Object.freeze({
	sections: { form }
})
